import { connect } from 'react-redux';
import { Link, ModelProps } from '../components/routing/Link';
import { AppState } from '../store';

const mapStateToProps = (state: AppState): ModelProps => ({
  location: state.router.location,
});

export const ConnectedLink = connect(mapStateToProps)(Link);
